import React, { createContext, useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import api from '../util/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [cookies, setCookie] = useCookies(['token']);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const token = cookies.token || null;

    useEffect(() => {
        if (!token) {
            setLoading(false);
            return;
        }

        (async () => {
            try {
                const resp = await api().getMe(token);
                if (resp.status === 200) {
                    setUser(resp.data);
                } else if (resp.status === 401) {
                    setCookie('token', null, { path: '/' });
                    setUser(null);
                }
            } catch (e) {
                setCookie('token', null, { path: '/' });
                setUser(null);
            } finally {
                setLoading(false);
            }
        })();
    }, [token]);

    const logout = () => {
        setCookie('token', null, { path: '/' });
        setUser(null);
        navigate('/');
    };

    const refreshUser = async () => {
        if (!token) return;
        try {
            const resp = await api().getMe(token);
            if (resp.status === 200) {
                setUser(resp.data);
            }
        } catch (e) { }
    };

    return (
        <AuthContext.Provider value={{ user, token, loading, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
